module.exports = __webpack_public_path__ + "static/media/portfolio1 (44).0035d729.jpeg";